







import Vue from 'vue';
import Customer from '../../../models/Customer';

export default Vue.extend({
  props: {
    customer: Customer,
  },
  methods: {
    showScoreRecords() {
      this.$emit('showScoreDetail', this.customer);
    },
  },
});
